module.exports = __webpack_public_path__ + "static/img/M7s Pro.efca881f.png";